
  // cine-collection-skin behavior with AJAX filter navigation. All filter
  // changes (checkbox toggle, Apply submit, chip click, sort change) fetch
  // the new URL and surgically replace [data-cinecoll] + the product grid.
  (function(){
    function closeAllPanels(){
      document.querySelectorAll('[data-cinepill].is-open').forEach(function(p){
        p.classList.remove('is-open');
        var btn = p.querySelector('[data-cinepill-toggle]');
        if (btn) btn.setAttribute('aria-expanded','false');
      });
      var sr = document.querySelector('[data-cinesort].is-open');
      if (sr){
        sr.classList.remove('is-open');
        var sb = sr.querySelector('[data-cinesort-toggle]');
        if (sb) sb.setAttribute('aria-expanded','false');
      }
      var bd = document.querySelector('[data-cinecoll-backdrop]');
      if (bd) bd.classList.remove('is-open');
      document.body.classList.remove('cinecoll-locked');
    }

    function isMobile(){ return window.matchMedia('(max-width: 760px)').matches; }

    function initCineColl(){
      var root = document.querySelector('[data-cinecoll]');
      if (!root) return;
      var form = root.querySelector('[data-cinerail]');
      var backdrop = document.querySelector('[data-cinecoll-backdrop]');
      var rail = root.querySelector('.cinecoll__rail');
      var autoSubmitTimer = null;

      function submitFilters(){
        if (!form) return;
        var fd = new FormData(form);
        var p = new URLSearchParams();
        fd.forEach(function(v, k){ if (v !== '' && v !== null) p.append(k, v); });
        var url = window.location.pathname + (p.toString() ? '?' + p.toString() : '');
        ajaxNavigate(url);
      }

      // Pill toggle
      root.querySelectorAll('[data-cinepill]').forEach(function(pill){
        var btn = pill.querySelector('[data-cinepill-toggle]');
        if (!btn) return;
        btn.addEventListener('click', function(e){
          e.stopPropagation();
          var willOpen = !pill.classList.contains('is-open');
          closeAllPanels();
          if (willOpen){
            pill.classList.add('is-open');
            btn.setAttribute('aria-expanded','true');
            if (isMobile()){
              if (backdrop) backdrop.classList.add('is-open');
              document.body.classList.add('cinecoll-locked');
            }
          }
        });
      });

      root.querySelectorAll('[data-cinepill-close]').forEach(function(b){
        b.addEventListener('click', closeAllPanels);
      });

      // Clear button — uncheck + ajax
      root.querySelectorAll('[data-cinepill-clear]').forEach(function(b){
        b.addEventListener('click', function(){
          var panel = b.closest('.cinepill__panel');
          if (!panel) return;
          panel.querySelectorAll('input[type="checkbox"]').forEach(function(c){ c.checked = false; });
          panel.querySelectorAll('input[type="number"]').forEach(function(n){ n.value = ''; });
          clearTimeout(autoSubmitTimer);
          submitFilters();
        });
      });

      // Auto-submit on filter change (debounced)
      root.querySelectorAll('[data-cinepill] input[type="checkbox"]').forEach(function(c){
        c.addEventListener('change', function(){
          clearTimeout(autoSubmitTimer);
          autoSubmitTimer = setTimeout(submitFilters, 350);
        });
      });
      root.querySelectorAll('[data-cinepill] input[type="number"]').forEach(function(n){
        n.addEventListener('change', function(){
          clearTimeout(autoSubmitTimer);
          autoSubmitTimer = setTimeout(submitFilters, 350);
        });
      });

      // Apply button (form submit)
      if (form){
        form.addEventListener('submit', function(e){
          e.preventDefault();
          clearTimeout(autoSubmitTimer);
          submitFilters();
        });
      }

      // Custom sort dropdown — preserves active filter params from the URL,
      // only swaps sort_by, then reuses the same AJAX navigation.
      var sortRoot = root.querySelector('[data-cinesort]');
      if (sortRoot){
        var sortBtn = sortRoot.querySelector('[data-cinesort-toggle]');
        if (sortBtn){
          sortBtn.addEventListener('click', function(e){
            e.stopPropagation();
            var willOpen = !sortRoot.classList.contains('is-open');
            closeAllPanels();
            if (willOpen){
              sortRoot.classList.add('is-open');
              sortBtn.setAttribute('aria-expanded','true');
            }
          });
        }
        sortRoot.querySelectorAll('[data-sort-value]').forEach(function(opt){
          opt.addEventListener('click', function(){
            var val = opt.getAttribute('data-sort-value');
            var p = new URLSearchParams(window.location.search);
            p.set('sort_by', val);
            p.delete('page');
            ajaxNavigate(window.location.pathname + '?' + p.toString());
          });
        });
      }

      // Active filter chips — remove via ajax
      root.querySelectorAll('a.cinechip').forEach(function(a){
        a.addEventListener('click', function(e){
          e.preventDefault();
          ajaxNavigate(a.getAttribute('href'));
        });
      });

      // Sticky shadow sentinel
      if (rail && 'IntersectionObserver' in window){
        var sentinel = rail.parentNode.querySelector('.cine-sentinel');
        if (!sentinel){
          sentinel = document.createElement('div');
          sentinel.className = 'cine-sentinel';
          sentinel.style.cssText = 'height:1px;position:relative;top:-1px';
          rail.parentNode.insertBefore(sentinel, rail);
        }
        new IntersectionObserver(function(entries){
          rail.classList.toggle('is-stuck', !entries[0].isIntersecting);
        }, { threshold: 0 }).observe(sentinel);
      }
    }

    function ajaxNavigate(url){
      closeAllPanels();
      document.body.classList.add('cinecoll-loading');
      fetch(url, { headers: { 'Accept': 'text/html', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
        .then(function(r){ return r.text(); })
        .then(function(html){
          var doc = new DOMParser().parseFromString(html, 'text/html');

          var newSkin = doc.querySelector('[data-cinecoll]');
          var oldSkin = document.querySelector('[data-cinecoll]');
          if (newSkin && oldSkin) oldSkin.parentNode.replaceChild(newSkin, oldSkin);

          var oldGrid = document.querySelector('#ProductGridContainer') || document.querySelector('.collection--empty');
          var newGrid = doc.querySelector('#ProductGridContainer') || doc.querySelector('.collection--empty');
          if (newGrid && oldGrid){
            // Replace closest .collection wrapper if both exist, so empty<->grid swap works
            var oldWrap = oldGrid.closest('.collection') || oldGrid;
            var newWrap = newGrid.closest('.collection') || newGrid;
            oldWrap.parentNode.replaceChild(newWrap, oldWrap);
          }

          history.pushState({}, '', url);
          initCineColl();
          document.body.classList.remove('cinecoll-loading');
        })
        .catch(function(){
          window.location.href = url;
        });
    }

    // Global handlers attached once
    document.addEventListener('click', function(e){
      if (e.target.closest('[data-cinepill]')) return;
      if (e.target.closest('[data-cinesort]')) return;
      if (e.target.closest('.cinecoll__backdrop')) return;
      closeAllPanels();
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape') closeAllPanels();
    });
    var backdropEl = document.querySelector('[data-cinecoll-backdrop]');
    if (backdropEl) backdropEl.addEventListener('click', closeAllPanels);
    window.addEventListener('popstate', function(){
      ajaxNavigate(window.location.pathname + window.location.search);
    });

    if (document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', initCineColl);
    } else {
      initCineColl();
    }
  })();
  
/* Mobile "Filter" toggle: reveal/hide the pill-rail; persist open state across the
   auto-submit reload so the filters stay expanded until the user collapses them. */
document.addEventListener('click',function(e){
  var b=e.target.closest('[data-cine-mfilter]'); if(!b)return;
  var coll=b.closest('.cinecoll'); if(!coll)return;
  var open=coll.classList.toggle('is-mfilter-open');
  b.setAttribute('aria-expanded',open?'true':'false');
  try{ open ? sessionStorage.setItem('cineMobileFilters','1') : sessionStorage.removeItem('cineMobileFilters'); }catch(err){}
});
(function restoreMobileFilters(){
  function apply(){
    try{ if(sessionStorage.getItem('cineMobileFilters')!=='1') return; }catch(err){ return; }
    var coll=document.querySelector('.cinecoll'); if(!coll) return;
    coll.classList.add('is-mfilter-open');
    var btn=coll.querySelector('[data-cine-mfilter]'); if(btn) btn.setAttribute('aria-expanded','true');
  }
  if(document.readyState!=='loading') apply(); else document.addEventListener('DOMContentLoaded',apply);
})();
